import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopSplitPaymentDetailResponse } from '@/repositories/generated';

const response: ShopSplitPaymentDetailResponse = {
  bonusPaymentMonths: [6, 7, 8, 10, 11, 12],
  hasReservationToApprove: true,
  id: '000000001',
  shopPaymentCategories: [
    {
      /*
      適用日前かつ予約者閲覧用の情報（編集不可）
      支払区分=61を含む
      手数料区分=特別
      */
      feeCategory: '05',
      paymentCategories: ['10', '23', '24', '61'],
      reservationInfo: {
        id: 1,
        reservationApplyDate: '2099-10-11T00:00:00+09:00',
        reservationStatus: 'RESERVED',
        reservedBy: 1,
        reservedPaymentCategories: ['61'],
        reservedBonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
        reservedInstallmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
      },
      bonusCombinedPaymentNumber: undefined,
      installmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60',
    },
    {
      /*
      適用日前かつ予約者以外閲覧用の情報（編集不可）
      支払区分=31,34,61を含む
      手数料区分=通常
      */
      feeCategory: '00',
      paymentCategories: ['10', '23', '24', '31', '34', '61', '80'],
      reservationInfo: {
        id: 1,
        reservationApplyDate: '2099-10-11T00:00:00+09:00',
        reservationStatus: 'RESERVED',
        reservedBy: 5,
        reservedPaymentCategories: ['10', '23', '24', '31', '34', '61'],
        reservedBonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
        reservedInstallmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
      },
      bonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90,99',
      installmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90,99',
    },
    {
      /*
      承認済みの適用日前の情報かつ予約者閲覧用の情報（編集不可）
      支払区分＝31を含む
      手数料区分=無金利
      */
      feeCategory: '01',
      paymentCategories: ['10', '23', '24', '31'],
      reservationInfo: {
        id: 1,
        reservationApplyDate: '2099-10-11T00:00:00+09:00',
        reservationStatus: 'APPROVED',
        reservedBy: 1,
        reservedPaymentCategories: ['10', '24', '31'],
        reservedBonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
        reservedInstallmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
      },
      bonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60',
      installmentPaymentNumber: undefined,
    },
    {
      /*
      承認済みの適用日前の情報かつ予約者以外閲覧用の情報（編集不可）
      支払区分=31,34,61を含まない
      手数料区分=通常
      */
      feeCategory: '00',
      paymentCategories: ['10', '23', '24'],
      reservationInfo: {
        id: 1,
        reservationApplyDate: '2099-10-11T00:00:00+09:00',
        reservationStatus: 'APPROVED',
        reservedBy: 5,
        reservedPaymentCategories: ['10', '23'],
        reservedBonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
        reservedInstallmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
      },
      bonusCombinedPaymentNumber: undefined,
      installmentPaymentNumber: undefined,
    },
    {
      // 適用日後の情報（現状は、B134バッチ適用前もバッチ適用後も編集不可）
      feeCategory: '06',
      paymentCategories: ['31', '34', '61'],
      reservationInfo: {
        // B134バッチ適用後の状態(reservationStatusがAPPLIEDになる)
        id: 1,
        reservationApplyDate: '2000-10-11T00:00:00+09:00',
        reservationStatus: 'APPLIED',
        reservedBy: 5,
        reservedPaymentCategories: ['31', '34', '61', '80'],
        reservedBonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
        reservedInstallmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10',
      },
      bonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90,99',
      installmentPaymentNumber: '1,2,3,4,5,6,7,8,9,10,20,30,40,50,60',
    },
    {
      // 編集可能な情報(予約情報がない場合)
      feeCategory: '00',
      paymentCategories: ['31', '34', '61'],
      reservationInfo: {
        id: undefined,
        reservationApplyDate: undefined,
        reservationStatus: undefined,
        reservedBy: undefined,
        reservedPaymentCategories: [],
        reservedBonusCombinedPaymentNumber: undefined,
        reservedInstallmentPaymentNumber: undefined,
      },
      bonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9',
      installmentPaymentNumber: '1,2,3,4,5,6,7,8,9',
    },
    {
      // 編集可能かつ削除可能な情報(予約情報がない場合)
      feeCategory: '06',
      paymentCategories: ['31', '34', '61'],
      reservationInfo: {
        id: undefined,
        reservationApplyDate: undefined,
        reservationStatus: undefined,
        reservedBy: undefined,
        reservedPaymentCategories: [],
        reservedBonusCombinedPaymentNumber: undefined,
        reservedInstallmentPaymentNumber: undefined,
      },
      bonusCombinedPaymentNumber: '1,2,3,4,5,6,7,8,9',
      installmentPaymentNumber: '1,2,3,4,5,6,7,8,9',
    },
  ],
};

export const shopSplitPaymentDetail = http.get(
  createMockEndpoint('/shop/:id([^\\(download\\)]+)/split_payment'), // shop/download/split_paymentとの競合を避ける
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
